import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { exchangeGoogleSession, formatApiErrorDetail } from '@/lib/api';
import { useAuth } from '@/context/AuthContext';
import Seo from '@/components/Seo';

export default function AuthCallback() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const u = await exchangeGoogleSession(sessionId);
        setUser(u);
        // Clean URL fragment
        window.history.replaceState(null, '', '/admin');
        navigate('/admin', { replace: true });
      } catch (e) {
        const msg = formatApiErrorDetail(e?.response?.data?.detail) || e.message;
        setError(msg);
        setTimeout(() => navigate('/login', { replace: true }), 2500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="section-light min-h-screen flex flex-col items-center justify-center bg-[var(--mw-bg)] text-white gap-4">
      <Seo title="Signing In" path="/auth/callback" noindex />
      {error ? (
        <div className="text-sm text-[var(--mw-primary)] max-w-md text-center px-6">
          {error}
        </div>
      ) : (
        <>
          <Loader2 className="animate-spin text-white/60" size={28} />
          <div className="text-xs uppercase tracking-[0.32em] text-white/55">
            Verifying session…
          </div>
        </>
      )}
    </div>
  );
}
